import * as React from 'react';
import {
  trumpetCommonQueryListNodeRecords,
  demandJournals,
  biddingJournals,
  outsourceDemandJournals,
  outsourceBiddingJournals,
  prepaymentJournalJournals,
  outsourcePrepaymentJournalJournals,
  JournalResDto,
  closedLoopCommonQueryListNodeRecords,
  kpiAdjustmentListNodeRecords,
  v2IpCooperationCommonQueryNodeRecords,
  outsourceV2IpCooperationNodeRecords,
} from 'services/api';
import { Spin } from '@bedrock/components';
import './index.less';
import OperationLog from '#features/StatusProgress/OperationLog';
import { $sType } from '#utils';
import { useMemo } from 'react';
import classnames from 'classnames';

const journalMapConfig = {
  inner: {
    CHANNEL_GROUP: {
      api: demandJournals,
    },
    MARKET_GROUP: {
      api: demandJournals,
    },
    BIDDING: {
      api: biddingJournals,
    },
    CD_TRUMPET_GROUP: {
      api: trumpetCommonQueryListNodeRecords,
    },
    M_CLOSED_LOOP: {
      api: closedLoopCommonQueryListNodeRecords,
    },
    KPI_ADJUSTMENT: {
      api: kpiAdjustmentListNodeRecords,
    },
    IP_COOPERATION_GROUP: {
      api: v2IpCooperationCommonQueryNodeRecords,
    },
    PREPAYMENT: {
      api: prepaymentJournalJournals,
    },
  },
  outer: {
    CHANNEL_GROUP: {
      api: outsourceDemandJournals,
    },
    MARKET_GROUP: {
      api: outsourceDemandJournals,
    },
    BIDDING: {
      api: outsourceBiddingJournals,
    },
    PREPAYMENT: {
      api: outsourcePrepaymentJournalJournals,
    },
    IP_COOPERATION_GROUP: {
      // 外包状态进度接口入参为 l2_id（内包统一为 id），包装统一为 { id } 供上层 api({ id }) 调用
      api: (p: { id: number }) => outsourceV2IpCooperationNodeRecords({ l2_id: p.id }),
    },
  },
};

const Index = (props: {
  // kpiAdjustmentListNodeRecords
  // 需求类型: 渠道，市场，比选，小喇叭
  groupType:
    | 'CHANNEL_GROUP'
    | 'MARKET_GROUP'
    | 'BIDDING'
    | 'CD_TRUMPET_GROUP'
    | 'M_CLOSED_LOOP'
    | 'KPI_ADJUSTMENT'
    | 'PREPAYMENT'
    | 'IP_COOPERATION_GROUP';
  projectId: number; // 单据id
  state: string; // 单据状态，如果单据流程会根据单据状态更新数据
  show: boolean; // 是否显示，如果显示才请求数据
  className?: string;
  style?: React.CSSProperties;
}) => {
  const { groupType, projectId, state, show } = props;
  const [journalData, setJournalData] = React.useState<JournalResDto>({});
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!projectId) return;
    if (show) {
      const api = journalMapConfig[$sType]?.[groupType]?.api;
      if (!api) return;
      setLoading(true);
      api({ id: projectId })
        .then((res) => {
          if (res.code === 1) {
            setJournalData(res.data as JournalResDto);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [projectId, state, show]);

  const operationLogProps = useMemo(() => {
    return {
      id: projectId,
      mapNodes: journalData?.map_nodes || [],
      remindState: journalData?.reminded_msg || {},
      journals: (journalData?.journals || []).reverse(),
      journal_type: journalData?.journal_type,
      notify_operate_user_list: journalData?.notify_operate_user_list || [],
    };
  }, [journalData]);

  if (!show) return null;

  if (loading)
    return (
      <div
        className={classnames('mpc-progress-loading', props.className)}
        style={props.style}
      >
        <Spin />
      </div>
    );

  return (
    <OperationLog
      className={props.className}
      style={props.style}
      {...operationLogProps}
    />
  );
};

export default Index;
